import { ErrorMessageWrapper } from "@/common/components/ErrorMessageWrapper";
import ListFilters from "@/common/components/ListFilters";
import LoadingSpinner from "@/common/components/LoadingSpinner";
import Table from "@/common/components/Table";
import TextField from "@/common/components/TextField";
import { cardTypeOptions } from "@/common/constants/cards.constant";
import useDebounce from "@/common/hooks/useDebounce";
import { useFilterParams } from "@/common/hooks/useFilterParams";
import { useCards } from "@/features/cards/hooks/useCards";
import { AllCardsTransformer } from "@/features/cards/services/allCardsTransformer";
import { companyCardsDefaultColumns } from "@/features/privateCompanies/constants/companyCardsDefaultColumns.constant";
import { SearchIcon } from "lucide-react";
import { useParams } from "react-router-dom";

const CompanyCardsList = () => {
  const { id } = useParams();

  const { filterParams, setFilterParams } = useFilterParams();

  const [searchCardNumber, setSearchCardNumber] = useDebounce(filterParams.card_number);

  const {
    meta,
    data: cards,
    isPending: cardsIsPending,
    isFetching: cardsisFetching,
    error: cardsError = {} as any,
    refetch: refetchCards,
  } = useCards({
    filters: {
      company_id: id,
      search: searchCardNumber,
      type: filterParams.card_type?.value,
      page: Number(filterParams.page) || 1,
    },
    mapper: AllCardsTransformer.tableTransformer(),
  });

  return (
    <ErrorMessageWrapper
      className="h-[calc(100vh-192px)]"
      statusCode={cardsError?.status}
      refetchFunction={refetchCards}
    >
      <div className="flex flex-col gap-6">
        <div className="flex flex-col gap-4">
          <TextField
            LeftIcon={<SearchIcon />}
            placeholder="Número do cartão ou Placa do veículo"
            className="rounded-sm shadow-[4px_0px_16px_0px_rgba(0,_0,_0,_0.5)]"
            onChange={(e) => {
              setSearchCardNumber((e.target as HTMLInputElement).value);
              setFilterParams((prev) => ({ ...prev, card_number: (e.target as HTMLInputElement).value, page: 1 }));
            }}
            value={filterParams.card_number}
          />
          <div className="flex justify-between">
            <ListFilters
              filters={[
                {
                  className: 'w-[128px]',
                  onChange: (e) => setFilterParams((prev) => ({ ...prev, card_type: e, page: 1 })),
                  value: filterParams.card_type,
                  options: [{ label: 'Todos', value: '' }, ...cardTypeOptions],
                  placeholder: 'Tipo'
                },
              ]}
            />
            <LoadingSpinner isLoading={cardsisFetching} />
          </div>
        </div>
        <Table
          className="max-h-[calc(100vh-324px)]"
          columns={companyCardsDefaultColumns}
          isLoadingData={cardsIsPending}
          page={filterParams.page || 1}
          rows={cards}
          totalPages={meta.total_pages}
          totalCount={meta.total}
          hasPagination
          setPage={(page) => setFilterParams((prev) => ({ ...prev, page }))}
        />
      </div>
    </ErrorMessageWrapper>
  );
}

export default CompanyCardsList;
